import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import Link from './Link';
import { ListItem } from '@mui/material';

const useStyles = makeStyles(theme => ({
  main: {
    fontSize: 14,
    color: theme.palette.text.primary,
  },

  secondary: {
    fontSize: 12,
    color: theme.palette.text.primary,
  },
}));

const MobileMenuNavItem = ({ title, link, variant }) => {
  const classes = useStyles();

  return (
    <ListItem disableGutters>
      <Link className={variant === 'main' ? classes.main : classes.secondary} href={link}>
        {title}
      </Link>
    </ListItem>
  );
};

MobileMenuNavItem.propTypes = {
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['main', 'secondary']),
};

MobileMenuNavItem.defaultProps = {
  variant: 'main',
};

export default MobileMenuNavItem;
